import { render, staticRenderFns } from "./display-shown-items-count.vue?vue&type=template&id=3a3c505b&scoped=true&"
import script from "./display-shown-items-count.vue?vue&type=script&lang=js&"
export * from "./display-shown-items-count.vue?vue&type=script&lang=js&"
import style0 from "./display-shown-items-count.vue?vue&type=style&index=0&id=3a3c505b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3c505b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3c505b')) {
      api.createRecord('3a3c505b', component.options)
    } else {
      api.reload('3a3c505b', component.options)
    }
    module.hot.accept("./display-shown-items-count.vue?vue&type=template&id=3a3c505b&scoped=true&", function () {
      api.rerender('3a3c505b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/display-shown-items-count.vue"
export default component.exports